import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import T from '../../../../SPRINTA/translate/T'

import PlaceHolder from '../../../atoms/PlaceHolder'
import HotelBox from '../../../molecules/HotelBox'
import SlickCarousel from '../../../third-party-v2/SlickCarousel'
import Modal from '../../../../SPRINTA/atoms/Modal'

import { Container, Row, Col } from '../../../atoms/Grid'

import style from './style.css'
import Accommodation from './Accommodation';

export default class ListPrices extends Component {
    static propTypes = {
        token: PropTypes.string.isRequired
    }

    state = {
        extras: null,
        lightBox: false,
        indexImageLightBox: 0,
        images: [],
        productId: null
    }

    componentWillMount() {
        axios.get(`events/accommodation/${this.props.token}`)
        .then(resp => {

            let images = []
            resp.forEach( (element, key) => {
                if(element.image) {
                    let image = `${window.config.url_event_extras_images}${element.image}`
                    images.push(image)
                    resp[key].image = image
                }
            })

            this.setState({
                extras: resp,
                images
            })

        })
    }

    openImage(key) {
        this.setState({
            indexImageLightBox: key,
            lightBox: true
        })
    }

    render() {
        if(this.state.extras !== null && this.state.extras.length === 0) return <span />

        return (
            <div className={style.bgGrey}>
                <Container>
                    <Row>
                        <Col size={8}>
                            { this.state.extras === null && (
                                <Row>
                                    <Col size={4}>
                                        <PlaceHolder type='retangle'/>
                                    </Col>
                                    <Col size={4}>
                                        <PlaceHolder type='retangle'/>
                                    </Col>
                                    <Col size={4}>
                                        <PlaceHolder type='retangle'/>
                                    </Col>
                                </Row>
                            )}

                            { this.state.extras !== null && (
                                <div>
                                    <div className={style.title}>{T.text('accommodation')}</div>
                                    
                                        <SlickCarousel itens='2' arrows={this.state.extras.length > 2 ? true : false} centerPaddingMobile='0'>
                                            { this.state.extras.map( (extra, k) => (
                                                <Col size='12' key={extra.id}>
                                                    <Row>
                                                        <HotelBox
                                                            image={extra.image !== '' ? extra.image : null}
                                                            title={extra.description}
                                                            starting_price={extra.starting_value}
                                                            max_guests={extra.max_guests}
                                                            handleShow={() => this.setState({
                                                                productId: extra.id
                                                            })}
                                                            />
                                                    </Row>
                                                </Col>
                                            )) }
                                        </SlickCarousel>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <Modal
                      active={this.state.productId ? true : false}
                      handleClose={() => this.setState({
                          productId: null
                      })}
                      style={{
                          width: '800px'
                      }}>
                        <Accommodation event={this.props.token} id={this.state.productId} />
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/templates/Event/ListHotel/index.js